export const carleadQuestionnaireWithBuyCarQuestionPartialFlow = {
  SELLPOINT: {
    name: 'SELLPOINT',
    cookieName: 'surveySellpoint',
    next: ['SELL_TYPES', 'email'],
    nodeType: 'questionnaireField',
    inputFieldType: 'select',
    guards: {
      SELL_TYPES: ['SELLPOINT_NOW', 'SELLPOINT_4_WEEKS', 'SELLPOINT_3_MONTHS'],
      email: ['SELLPOINT_NOT_PLANNED']
    }
  },
  SELL_TYPES: {
    name: 'SELL_TYPES',
    cookieName: 'surveySelltypes',
    next: ['BUY_CAR'],
    nodeType: 'questionnaireField',
    inputFieldType: 'select',
    guards: {
      BUY_CAR: ['DEALER', 'PRIVATE']
    }
  },
  BUY_CAR: {
    name: 'BUY_CAR',
    next: ['email'],
    nodeType: 'questionnaireField',
    inputFieldType: 'select',
    guards: {
      email: ['YES', 'NO']
    }
  }
};